
import { Component, Prop, Vue } from 'vue-property-decorator';
import ConsentCheckBox from '~/components/User/Consents/MarketingConsents/ConsentCheckBox.vue';
import { MarketingsConsents } from '~/interfaces/user.interface';
@Component({
    components: { ConsentCheckBox },
})
export default class ContainerConsents extends Vue {
    @Prop() consentsObject : MarketingsConsents | undefined
    @Prop() title : 'Channels' | 'Interests' | undefined
}
